import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetBulkQuickOrderApiParameter } from "@store/Store/CommonHandlers/BulkAddToQuickOrder";
import { BulkAddToCartState } from "@store/Store/Data/QuickOrder/BulkAddToCartState";
import { Draft } from "immer";

const initialState: BulkAddToCartState = {
    isLoading: false,
};

const reducer = {
    "Store/Data/QuickOrder/BeginLoadProducts": (
        draft: Draft<BulkAddToCartState>,
        action: { parameter: GetBulkQuickOrderApiParameter },
    ) => {
        draft.isLoading = true;
    },
    "Store/Data/QuickOrder/CompleteLoadProducts": (
        draft: Draft<BulkAddToCartState>,
        action: { parameter: GetBulkQuickOrderApiParameter },
    ) => {
        draft.isLoading = false;
    },
};

const bulkAddToCartReducer = createTypedReducerWithImmer(initialState, reducer);
export default bulkAddToCartReducer;
